<template lang="pug">
  .sv-select-item-component(v-on-away="away")
    .media
      .media-left
        figure.image.is-96x96(v-if="item.image_urls")
          img(:src="item.image_urls.min")
        figure.image.is-96x96(v-else)
          img(src="/webapp/images/workers/worker-default.png")
      .media-content
        p {{'#'+item.id}} - {{item.first_name}} {{item.last_name}} &nbsp;
          router-link(:to="{name: 'ViewCV', params: {lang: getLanguage, id: item.id, prev: $route.query.page}}" target= '_blank').link ({{gettext('Show')}})
        p(v-if="item.has_profession && item.profession") {{item.profession_company_type.name}} | {{item.profession_company_sector.name}} | {{item.profession.name}}
        p(v-else-if="item.has_profession && item.profession_company_type") {{item.profession_company_type.name}}
        p
          span.tag.is-success(v-for="type in item.looking_for_company_types") {{type.name}}
        p.subtitle {{ gettext('Created') }}: {{item.created_dt | date}}
      .media-right
        button.button(@click="select(item)" :class="{'is-success': confirm}") {{ confirm ? gettext('Confirm') : gettext('Select') }}
    .content(v-if="confirm")
      .notification.is-warning {{gettext('Do you really want to send this CV?')}}
</template>
<script>
import { gettext } from '@/services/TranslateHandler'
import { directive as onAway } from 'vue-clickaway'
import { mapGetters } from 'vuex'

const moment = require('moment')

export default {
  name: 'CVSelectItemComponent',
  directives: {
    onAway
  },
  data () {
    return {
      confirm: false
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  },
  props: {
    item: {
      default: () => {
        return {}
      }
    }
  },
  methods: {
    gettext: gettext,
    select (item) {
      if (this.confirm) this.$emit('selected', item)
      this.confirm = true
    },
    away () {
      this.confirm = false
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/vacancy/parts/offer/components/cv-select-item/index.vue